/**
 * Roman numerals — pure, deterministic conversion (1–3999).
 * Safe to render server-side.
 */

const TABLE: ReadonlyArray<readonly [number, string]> = [
  [1000, "M"],
  [900, "CM"],
  [500, "D"],
  [400, "CD"],
  [100, "C"],
  [90, "XC"],
  [50, "L"],
  [40, "XL"],
  [10, "X"],
  [9, "IX"],
  [5, "V"],
  [4, "IV"],
  [1, "I"],
];

const VALUES: Record<string, number> = {
  I: 1,
  V: 5,
  X: 10,
  L: 50,
  C: 100,
  D: 500,
  M: 1000,
};

// Strict canonical Roman numeral (1–3999).
const VALID = /^M{0,3}(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})$/;

/** Integer 1–3999 → Roman numeral, or null if out of range. */
export function toRoman(n: number): string | null {
  if (!Number.isInteger(n) || n < 1 || n > 3999) return null;
  let num = n;
  let out = "";
  for (const [value, sym] of TABLE) {
    while (num >= value) {
      out += sym;
      num -= value;
    }
  }
  return out;
}

/** Roman numeral → integer, or null if not a valid canonical numeral. */
export function fromRoman(s: string): number | null {
  const str = s.trim().toUpperCase();
  if (str === "" || !VALID.test(str)) return null;
  let total = 0;
  for (let i = 0; i < str.length; i++) {
    const cur = VALUES[str[i]];
    const next = i + 1 < str.length ? VALUES[str[i + 1]] : 0;
    total += cur < next ? -cur : cur;
  }
  return total;
}
